import React, { FC, Fragment } from 'react';
import { Link, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useContent } from 'hooks';
import { MinimalPost } from 'api';
import { generateLink } from 'Links';
import { Separator } from 'components';

const Groups: FC = () => {
  const { t } = useTranslation();
  const content = useContent() as MinimalPost;

  const { primary_group, groups } = content;
  const repostGroups = groups?.filter(group => group?.id !== primary_group?.id) || [];

  function renderPrimaryGroup() {
    if (!primary_group) {
      return null;
    }

    return (
      <Link component={generateLink(`/group/${primary_group?.id}`)} underline="hover">
        <Typography>{primary_group?.title}</Typography>
      </Link>
    );
  }

  function renderTooltipTitles() {
    return repostGroups.map(group => (
      <Link component={generateLink(`/group/${group.id}`)} key={group.id} underline="hover">
        <Typography>{group.title}</Typography>
      </Link>
    ));
  }

  return (
    <Fragment>
      {renderPrimaryGroup()}
      {!!repostGroups.length && (
        <Fragment>
          <Separator color="textSecondary" />

          <Tooltip title={renderTooltipTitles()}>
            <Typography color="textSecondary">
              {`${t('posting:repost')} +${repostGroups.length}`}
            </Typography>
          </Tooltip>
        </Fragment>
      )}
      <Separator />
    </Fragment>
  );
};

export default Groups;
